import { handleErrorWithSentry } from "@sentry/sveltekit";
import * as Sentry from '@sentry/sveltekit';
import { initializeCustomErrorReporting } from "$lib/sentry";
import { initializeMobileContext } from "$lib/sentry/mobile-context";

// Initialize Sentry with environment-based configuration
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || 'https://7bb597a40e16fe4bb1dc3e2d73efc2cd@o4509803705729024.ingest.de.sentry.io/4509803745706064',

  // Release version for session tracking and error correlation
  release: import.meta.env.VITE_APP_VERSION || `dev@${new Date().toISOString().split('T')[0]}`,

  environment: import.meta.env.MODE,
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Privacy-first configuration (following backend standards)
  sendDefaultPii: false,

  // Privacy filter for sensitive data (following backend patterns)
  beforeSend: (event) => {
    if (event.request?.data && typeof event.request.data === 'object') {
      const sensitiveFields = ['password', 'token', 'secret', 'key', 'authorization', 'fcmToken', 'vapidKey'];
      const requestData = event.request.data as Record<string, any>;

      for (const field of sensitiveFields) {
        if (field in requestData) {
          requestData[field] = '[Filtered]';
        }
      }
    }

    // Filter sensitive data from extra context
    if (event.extra) {
      const sensitiveFields = ['fcmToken', 'vapidKey', 'authToken', 'accessToken'];
      for (const field of sensitiveFields) {
        if (event.extra[field]) {
          event.extra[field] = '[Filtered]';
        }
      }
    }

    return event;
  },

  // Debug mode for development
  debug: import.meta.env.DEV,

  // Set initial tags for basic device info
  initialScope: {
    tags: {
      platform: 'web',
      environment: import.meta.env.MODE,
      appVersion: import.meta.env.VITE_APP_VERSION || 'unknown'
    }
  }
});

// Initialize custom error reporting after Sentry is ready
initializeCustomErrorReporting();

// Initialize mobile context collection for enhanced debugging
initializeMobileContext().catch(error => {
  console.warn('Failed to initialize mobile context:', error);
});

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry();
